import React from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { DescriptionOutlined, HelpOutlineOutlined } from '@material-ui/icons';
import { Grid, Typography, withStyles } from '@material-ui/core';
import styled from 'themed-components';

export enum ToggleOptions {
	Invoice = 1,
	NonInvoice = 2
}

const StyledToggleButtonGroup = withStyles((theme) => ({
	grouped: {
		style: {
			display: 'flex',
			flex: '1'
		},
		'&': {
			flex: 2
		},
		'&.Mui-selected': {
			backgroundColor: theme.palette.primary.dark,
			color: theme.palette.primary.contrastText
		},
		'&:hover:not(.Mui-selected)': {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.primary.contrastText
		},
		'&:hover.Mui-selected': {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		}
	}
}))(ToggleButtonGroup);

export interface ToggleProps {
	onChange: (selected: ToggleOptions) => void;
}

const SvgWrapper = styled.div``;
const TextWrapper = styled.div``;

export const Toggle = ({ onChange }: ToggleProps) => {
	const [selected, select] = React.useState<ToggleOptions>();

	const onToggleChange = (_: React.MouseEvent<HTMLElement>, newAlignment: ToggleOptions) => {
		select(newAlignment);
		onChange(newAlignment);
	};

	return (
		<StyledToggleButtonGroup value={selected} exclusive onChange={onToggleChange} color="primary" aria-label="mail type">
			<ToggleButton selected={selected == ToggleOptions.Invoice} value={ToggleOptions.Invoice} aria-label="invoice">
				<Grid container>
					<Grid xs={12} item>
						<SvgWrapper>
							<DescriptionOutlined fontSize="small" />
						</SvgWrapper>
					</Grid>
					<Grid xs={12} item>
						<TextWrapper>
							<Typography variant="subtitle2" component="div">
								Invoice
							</Typography>
						</TextWrapper>
					</Grid>
				</Grid>
			</ToggleButton>

			<ToggleButton selected={selected == ToggleOptions.NonInvoice} value={ToggleOptions.NonInvoice} aria-label="non invoice">
				<Grid container>
					<Grid item xs={12}>
						<SvgWrapper>
							<HelpOutlineOutlined fontSize="small" />
						</SvgWrapper>
					</Grid>
					<Grid item xs={12}>
						<TextWrapper>
							<Typography variant="subtitle2" component="div">
								Non-Invoice
							</Typography>
						</TextWrapper>
					</Grid>
				</Grid>
			</ToggleButton>
		</StyledToggleButtonGroup>
	);
};
